import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManagePodcast() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function createPodcast(data) {
    return privateFetch.post('/v1/admin/podcasts', data).then((res) => res.data);
  }

  function updatePodcast({ podcastId, ...rest }) {
    return privateFetch.put(`/v1/admin/podcast/${podcastId}`, rest);
  }

  function managePodcast(data) {
    console.log('🚀 ~ managePodcast ~ data:', data);
    if (data.podcastId) return updatePodcast(data);
    return createPodcast(data);
  }

  return useMutation(managePodcast, {
    onSuccess(responseData) {
      console.log('🚀 ~ onSuccess ~ response:', responseData);
    },
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('podcast');
    },
  });
}

export default useManagePodcast;
